import {useEffect} from 'react';

export default (promptVisible = false): void => {
    const beforeUnload = (event: any) => {
        if (!promptVisible) {
            return;
        }
        const e = event || window.event;
        e.preventDefault();
        if (e) {
            e.returnValue = '';
        }
        return '';
    };

    useEffect(() => {
        window.addEventListener('beforeunload', beforeUnload);

        return () => {
            window.removeEventListener('beforeunload', beforeUnload);
        };
    }, [promptVisible]);

    return;
};
